module.exports = __webpack_public_path__ + "static/media/cisce_logo.efd32043.webp";